const Config = {
   BaseUrl: 'https://api.inspectthiscar.com/api',
   // BaseUrl: 'http://52.38.146.198/api',
   // BaseUrl: 'http://localhost:5000/api',
   // BaseUrl: 'http://192.168.1.27:3000/api',  
   // BaseUrl:'http://127.0.0.1:3001/api',
   Currency: 'CAD',
};

export default Config;
